export const getThemeProps = (rootEl = document.getElementById('root')) => ({
  palette: {
    primary: {
      main: '#0891b2',
    },
    background: {
      default: '#ffffff',
      paper: '#ffffff',
    },
  },
  components: {
    MuiUseMediaQuery: {
      defaultProps: {
        noSsr: true,
      },
    },
    ...(rootEl
      ? {
          MuiPopover: {
            defaultProps: {
              container: rootEl,
            },
          },
        }
      : {}),
    ...(rootEl
      ? {
          MuiPopper: {
            defaultProps: {
              container: rootEl,
            },
          },
        }
      : {}),
  },
  typography: {
    allVariants: {
      fontFamily: [
        'Poppins',
        'Nunito',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
      ].join(','),
    },
  },
});
